const SKYBOX_PRESETS = [
  { id: 'echopark', label: '城市公园', filename: 'Echopark.png', sourceType: 'envAtlas' },
  { id: 'vertebrae', label: '柔光影棚', filename: 'VertebraeHDRI_v1_512.png', sourceType: 'envAtlas' },
  { id: 'whiteCyclorama', label: '白棚影棚', filename: 'ProductWhiteCyclorama.png', sourceType: 'equirect' },
  { id: 'warmTabletop', label: '暖木台面', filename: 'ProductWarmTabletop.png', sourceType: 'equirect' },
  { id: 'marblePedestal', label: '大理石展台', filename: 'ProductMarblePedestal.png', sourceType: 'equirect' },
  { id: 'darkGallery', label: '暗色展厅', filename: 'ProductDarkGallery.png', sourceType: 'equirect' },
  { id: 'retailShowroom', label: '零售展厅', filename: 'ProductRetailShowroom.png', sourceType: 'equirect' },
  { id: 'industrialLoft', label: '工业阁楼', filename: 'ProductIndustrialLoft.png', sourceType: 'equirect' },
  { id: 'museumAtrium', label: '博物馆中庭', filename: 'ProductMuseumAtrium.png', sourceType: 'equirect' },
  { id: 'neonShowcase', label: '霓虹展台', filename: 'ProductNeonShowcase.png', sourceType: 'equirect' }
].map(preset => ({ ...preset, url: `env/${preset.filename}` }))

const DEFAULT_SKYBOX_PRESET = 'echopark'

function getSkyboxPreset(id) {
  return SKYBOX_PRESETS.find(preset => preset.id === id) ||
    SKYBOX_PRESETS.find(preset => preset.id === DEFAULT_SKYBOX_PRESET)
}

export { DEFAULT_SKYBOX_PRESET, SKYBOX_PRESETS, getSkyboxPreset }
